export const adnPreview = async (context: string, creativeId: string) => {
    const r = await fetch(`https://delivery.adnuntius.com/preview?context=${context}&creativeId=${creativeId}`);
    const body = await r.text();
    return body;
};
